var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8"},[_c('h3',[_vm._v("Beskrivelse")]),(_vm.product.description)?_c('span',[_vm._v(" "+_vm._s(_vm.product.description))]):_c('span',{staticClass:"text--disabled"},[_vm._v(" Ingen beskrivelse")])])}
var staticRenderFns = []

export { render, staticRenderFns }